<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- Left Column - Company -->
      <div class="footer-column">
        <h3 class="column-title">公司</h3>
        <div class="column-links">
          <router-link to="/user/about" class="footer-link">关于我们</router-link>
          <router-link to="/user/contact" class="footer-link">联系我们</router-link>
        </div>
      </div>
      <div class="footer-column">
        <h3 class="column-title">法律</h3>
        <div class="column-links">
          <a target="_blank"
                       href="https://docs.qq.com/doc/DYlZkWFVQUmV3Y0ZZ"
                       class="footer-link">用户协议</a>
          <a  target="_blank"
              href="https://docs.qq.com/doc/DYlJXSEVHYUF4SElo"
              class="footer-link">隐私协议</a>
        </div>
      </div>
      <div class="footer-column">
        <h3 class="column-title">认证</h3>
        <div class="column-links">
          <div class="computer"></div>
          <div class="three-home"></div>
        </div>
      </div>
      <div class="footer-column">
        <h3 class="column-title">
          <img src="../../assets/footer-logo.png" alt="">
        </h3>
        <div class="column-links">
          <span>公安网安备51019002007645号 蜀ICP备2021009784号-16</span>
          <span>成都精诚绿洲网络科技有限公司</span>
        </div>
      </div>
      <!-- Right Column - Contact/Follow Us -->
      <div class="footer-column">
        <h3 class="column-title">联系/关注我们</h3>
        <div class="contact-section">
          <div class="contact-item">
            <div class="contact-header">
              <div class="contact-icon">
                <img src="../../assets/qq.png" alt="" class="icon-text" />
              </div>
              <span class="contact-text">官方QQ群</span>
            </div>
            <div class="contact-number">1045324770</div>
            <div class="qr-code qq-qr">
              <div class="qr-placeholder">
                <div class="crowd"></div>
<!--                <img src="../../assets/crowd.png" alt="" />-->
              </div>
            </div>
          </div>
          <div class="contact-item">
            <div class="contact-header">
              <div class="contact-icon">
                <img src="../../assets/wechat.png" alt="" class="icon-text" />
              </div>
              <span class="contact-text">ZZ游戏助手</span>
            </div>
            <div class="contact-number">微信公众号</div>
            <div class="qr-code qq-qr">
              <div class="qr-placeholder">
                <div class="wx-account"></div>
<!--                <img src="../../assets/account.png" alt="" />-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #1F1F1E;
  color: white;
  width: 100%;
  height: 197px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-container {
  max-width: 1200px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 30px  40px 0 40px;
  height: 100%;
  align-items: flex-start;
}

.footer-column {
  display: flex;
  flex-direction: column;
  margin: 0 20px;
}
.column-title {
  font-size: 16px;
  color: #bdc3c7;
  margin-bottom: 20px;
  font-weight: 500;
}

.column-links {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.footer-link {
  color: white;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.3s;
  font-weight: 400;
}

.footer-link:hover {
  color: #3498db;
}
.contact-section {
  display: flex;
  gap: 20px;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.contact-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-text {
  font-size: 13px;
  color: white;
  font-weight: 400;
}

.contact-number {
  font-size: 13px;
  color: white;
  font-weight: 400;
  margin-left: 26px;
}

.qr-code {
  width: 60px;
  height: 60px;
  margin-left: 26px;
}

.qr-placeholder {
 width: 64px;
  height: 64px;
  background-color: #34495e;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7f8c8d;
  font-size: 9px;
  border-radius: 6px;
  text-align: center;
  line-height: 1.2;
}

.qq-qr .qr-placeholder {
  background-color: #3498db;
  border-color: #2980b9;
  color: white;
}

.wx-qr .qr-placeholder {
  background-color: #2c3e50;
  border-color: #34495e;
  color: #bdc3c7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    height: auto;
    min-height: 197px;
    padding: 20px 0;
  }

  .footer-container {
    flex-direction: column;
    gap: 30px;
    padding: 0 20px;
    align-items: center;
  }

  .footer-column {
    margin: 0;
    text-align: center;
    width: 100%;
  }

  .contact-section {
    align-items: center;
  }

  .contact-item {
    align-items: center;
  }

  .contact-number {
    margin-left: 0;
  }

  .qr-code {
    margin-left: 0;
  }
}
.computer {
  background-image: url("../../assets/computer.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 104px;
  height: 24px;
}
.three-home {
  background-image: url("../../assets/360.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 104px;
  height: 24px;
}
.crowd{
  width: 64px;
  height: 64px;
  background-image: url("../../assets/crowd.png");
  background-repeat: no-repeat;
  background-size: cover;

}
.wx-account {
  width: 64px;
  height: 64px;
  background-image: url("../../assets/account.png");
  background-repeat: no-repeat;
  background-size: cover;

}
</style>
